import * as React from "react";
import SelectBase, { SelectOption } from "./global/SelectBase";
import { SelectChangeEvent } from "@mui/material/Select";

const SelectSimple = ({
  data,
  onChange,
  title,
  sx,
  value,
  size = "small",
}: {
  data: Array<SelectOption>;
  onChange: (event: SelectChangeEvent) => void;
  title: string;
  sx?: any;
  value: string;
  size?: "small" | "medium";
}) => {
  const selected = React.useMemo(
    () => data?.find((it) => it.value == value) || null,
    [data, value]
  );

  const handleChange = (newValue: SelectOption | SelectOption[] | null) => {
    const singleValue = Array.isArray(newValue) ? newValue[0] : newValue;
    const event = {
      target: { value: singleValue?.value || null },
    } as SelectChangeEvent;
    onChange(event);
  };

  return (
    <SelectBase
      options={data}
      value={selected}
      onChange={handleChange}
      label={title}
      sx={sx}
    />
  );
};
export default SelectSimple;
